import { useQuery } from "@apollo/client";
import { GET_CURRENT_USER } from "./userQueries";

export default function useUser() {
    const { data, loading } = useQuery(GET_CURRENT_USER);
    return { user: data?.authenticatedItem, loading };
}
